import { Button as StandardButton, LoadingIndicator } from '@emorg-prd/standard-react';
import React from 'react';

export enum ButtonVariant {
	Primary = 'em-c-btn--primary',
	Secondary = 'em-c-btn--secondary',
	Tertiary = 'em-c-btn--tertiary',
	Bare = 'em-c-btn--bare',
	Inverted = 'em-c-btn--inverted',
	InvertedRed = 'em-c-btn--inverted-red',
}

export type ButtonVariantType = 'primary' | 'secondary' | 'tertiary' | 'bare' | 'inverted' | 'inverted-red';
export type ButtonSizeType = 'small' | 'medium' | 'large';

const variantMap: Record<ButtonVariantType, ButtonVariant> = {
	primary: ButtonVariant.Primary,
	secondary: ButtonVariant.Secondary,
	tertiary: ButtonVariant.Tertiary,
	bare: ButtonVariant.Bare,
	inverted: ButtonVariant.Inverted,
	'inverted-red': ButtonVariant.InvertedRed,
};

const sizeMap: Record<ButtonSizeType, 'em-c-btn--small' | 'em-c-btn--large'> = {
	small: 'em-c-btn--small',
	medium: undefined,
	large: 'em-c-btn--large',
};

export interface ButtonProps extends Omit<React.ComponentProps<typeof StandardButton>, 'size'> {
	isIconOnlyButton?: boolean;
	isIconButton?: boolean;
	children?: React.ReactNode;
	isLoading?: boolean;
	variant?: ButtonVariantType;
	handleUpdateSubmit?: any;
	disabled?: boolean;
	name?: string;
	loadingVariant?: ButtonVariantType;
	size?: ButtonSizeType;
	optionalClass?: string;
	style?: Object
}

const Button: React.FC<ButtonProps> = (props) => {
	const buttonStyle = { borderRadius: '4px' };

	// Map strings
	const mappedVariant = variantMap[props.variant ?? 'primary'];
	const mappedLoadingVariant = variantMap[props.loadingVariant ?? 'primary'];
	const mappedSize = props.size ? sizeMap[props.size] : undefined;

	return (
		<>
			{!props.isLoading ? (
				<StandardButton
					{...props}
					style={buttonStyle}
					type={mappedVariant}
					disabled={props.disabled}
					label={props.name}
					size={mappedSize}
					isIconButton={props.isIconButton}
					isIconOnlyButton={props.isIconOnlyButton}
					optionalClass={props.optionalClass}
				>
					{props.children}
				</StandardButton>
			) : (
				<StandardButton
					variant={mappedLoadingVariant}
					style={buttonStyle}
					size={mappedSize}
					disabled={props.disabled}
					isIconButton
					isIconOnlyButton
				>
					<LoadingIndicator size="s" />
				</StandardButton>
			)}
		</>
	);
};

export { Button };
